module.exports = __webpack_public_path__ + "assets/img/8_1749.5f37751c.jpg";